export default "__VITE_ASSET__DYRP1lGM__"